import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTablet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTablet"><Path d="M4.5 2.5H19.5V21.5H4.5V2.5Z" stroke="currentColor"/><Path d="M8.5 18.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTablet;
